module.exports = [{"type":"title","text":"2025-05-14"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"公共：新增調查問卷"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-05-14.json
// module id = G4iE
// module chunks = 3